Pegasus.RowBackgroundColorView = Ember.View.extend({
  templateName: 'row_background_color',
  classNames: ['background-color']
});
